module.exports = __webpack_public_path__ + "static/media/slide-2.12a25e24.jpg";